<template>
  <EBadge v-if="parsed" class="duration-tag" variant="solid-dark">
    <EIcon
      class="duration-tag__icon"
      data-test-id="duration-tag-icon"
      icon="play"
      size="s"
    />
    <time :datetime="duration">
      {{ formatted }}
    </time>
  </EBadge>
</template>

<script>
import parseDuration from '@tehshrike/duration-iso-8601';

import EBadge from '~~/common/vue/components/badge';
import EIcon from '~~/common/vue/components/icon';

export default {
  name: 'EDurationTag',
  components: {
    EBadge,
    EIcon,
  },
  props: {
    duration: {
      type: String,
      required: true,
    },
  },
  computed: {
    parsed() {
      return parseDuration(this.duration);
    },
    formatted() {
      const parts = [
        this.formatPart(this.parsed.minute || 0),
        this.formatPart(this.parsed.second || 0),
      ];
      if (this.parsed.hour > 0) {
        parts.unshift(this.formatPart(this.parsed.hour || 0));
      }
      return parts.join(':');
    },
  },
  methods: {
    formatPart(part) {
      return String(part).padStart(2, '0');
    },
  },
};
</script>
